<template>
    <div class="news-cont">
        <div class="news-backTitle">
            <h1 class="common-font center">Media</h1>
        </div>
        <div class="news-title">
            <div class="news-mes center">
                <ul ref="newsTop">
                    <li v-for="(news,index) in newsLists" :key="index">
                        <router-link :to="{name:'detail1', params:{bid:news.newsId}}" tag="a">
                            <img :src="news.newsCover" :_src="news.newsCover1" alt="">
                            <div class="sub-title">
                                <h2 class="common-font">{{news.title}}</h2>
                                <p>{{news.date}}</p>
                                <span v-show="news.top">TOP</span>
                            </div>
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import newsLists from '../assets/js/news';
    export default {
        name: "newsList",
        data() {
            return {
                newsLists: newsLists.newsLists.newsLists,

            }
        },
        created() {
            this.newsSort();

        },
        mounted() {
            // this.newsTop();
            this.utils.getImg()
        },
        render() {


        },
        methods: {
            newsSort() {
                //新闻排序
                var newsOne = this.newsLists
                newsOne.sort((a, b) => {
                    return b.date.replace(/\//g, "") - a.date.replace(/\//g, "");
                });
                // //新闻置顶
                newsOne.find((item,index)=>{
                    if(item.top){
                        newsOne.splice(index,1)
                     return  newsOne.unshift(item)
                    }
                });

                //转换英文日期
                newsOne.forEach((item, index) => {
                    var _time = new Date(item.date).toDateString().slice(4, -4);
                    var _year = new Date(item.date).toDateString().slice(11, 15);
                    var _date = _time + ' , ' + _year;
                    // console.log(_year);
                    item.date = _date;
                })

            }
        },
        components: {}
    }
</script>

<style lang="less">
    .news-cont {
        @baseWidthNews: 1360px;
        width: 100%;
        .center {
            width: @baseWidthNews;
            margin: 0 auto;
        }
        .common-font{
            font-family: 'Gotham-Medium',"Avenir Next", 'Helvetica Neue', 'PingFang SC';
            font-weight: 500;
        }
        .news-backTitle {
            background: #fafafa;
            padding-top: 156px;
            margin-bottom: 36px;
            h1 {
                font-size: 40px;
                color: #252525;
                line-height: 64px;
                padding-bottom: 60px;
            }
        }
        .news-title {
            margin-top: 60px;
            .news-mes {
                ul {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    li {
                        margin-bottom: 80px;
                        img {
                            display: block;
                            width: 660px;
                            height: 440px;
                            -webkit-transition: all .5s;
                            transition: all .5s;
                        }
                        h2 {
                            font-size: 22px;
                            color: #252525;
                            line-height: 30px;

                        }
                        p {
                            display: inline-block;
                            font-size: 16px;
                            color: #5D5D5D;
                            line-height: 26px;
                            padding: 24px 0 32px;
                        }
                        a {
                            display: block;
                            overflow: hidden;
                            width: 100%;
                            /*height: 100%;*/
                            &:hover {
                                width: 100%;
                                height: 100%;
                                box-shadow: 0 0 5px 0 rgba(0, 0, 0, .1);
                                img {
                                    -webkit-transform: scale(1.03);
                                    transform: scale(1.03);
                                }
                                .sub-title {
                                    background: #fafafa;

                                }
                            }
                        }
                        .sub-title {
                            padding: 32px 32px 0 32px;
                            width: 660px;
                            -webkit-transition: all .5s;
                            transition: all .5s;
                            span {
                                display: inline-block;
                                width: 50px;
                                color: #fff;
                                margin-left: 10px;
                                background: #7281ad;
                                text-align: center;
                                font-size: 14px;
                                line-height: 26px;
                                border-radius: 4px;
                            }
                        }

                    }
                }
            }
        }

    }

    @media screen and (max-width: 1680px){
        .news-cont {
            @baseWidthNews: 1216px;
            @autoWidth:1256px;
            .center {
                width: @baseWidthNews;
                margin: 0 auto;
            }
            .news-title {
                width: 100%;
                min-width: @autoWidth;
                .news-mes {
                    ul {
                        li {
                            img {
                                display: block;
                                width: 590px;
                                height: 330px;
                            }
                            a {
                                display: block;
                                overflow: hidden;
                                width: 100%;
                                height: 100%;
                            }
                            .sub-title {
                                width: 590px;
                                padding: 32px 24px 0 24px;
                            }
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/newsList.vue